import { TabPanel } from 'common/components/TabPanel/TabPanel'
import { PATH_SEGMENT } from 'routes/pathSegments'
import { generateRouter } from 'routes/routes.utils'
import { DistinctPatients } from './DistinctPatients/DistinctPatients'
import { Prescriptions as AllPrescriptions } from './AllPrescriptions/Prescriptions'
import { Navigate } from 'react-router'

const tabs = [
  {
    path: PATH_SEGMENT.DISTINCT_PATIENTS,
    title: 'Distinct Patients',
  },
  {
    path: PATH_SEGMENT.ALL_PRESCRIPTIONS,
    title: 'Prescriptions',
  },
]
const routesConfig = {
  [PATH_SEGMENT.ROOT]: <Navigate to={PATH_SEGMENT.DISTINCT_PATIENTS} replace />,
  [PATH_SEGMENT.DISTINCT_PATIENTS]: <DistinctPatients />,
  [PATH_SEGMENT.ALL_PRESCRIPTIONS]: <AllPrescriptions />,
}

export const Prescriptions = () => {
  return (
    <>
      <TabPanel tabs={tabs} />
      {generateRouter(routesConfig)}
    </>
  )
}
